import styled from 'styled-components';
import { Base, Theme, ArticlePortableText } from 'styled';

type ModuleSwitchWrapperProps = {
  hasOverview: boolean;
};

type OverviewAndModuleSwitchContainerProps = {
  articleHasRelatedArticles: boolean;
};

export const Overview = styled(ArticlePortableText)`
  margin-top: 1.4375rem;
  margin-bottom: 4.25rem;

  ${Theme.mediaQueries.sm} {
    margin-top: 1.8125rem;
    margin-bottom: 4.75rem;
  }
`;

export const MainInnerAndSidePanelsContainer = styled(Base)`
  position: relative;
  margin: 0 auto;
  max-width: 77rem;

  ${Theme.mediaQueries.xl} {
    max-width: 81.25rem;
  }
`;

export const ModuleSwitchWrapper = styled(Base)<ModuleSwitchWrapperProps>`
  margin-top: ${({ hasOverview }) => hasOverview && '1.4375rem'};

  ${Theme.mediaQueries.sm} {
    margin-top: ${({ hasOverview }) => hasOverview && '1.8125rem'};
  }
`;

export const OverviewAndModuleSwitchContainer = styled(
  Base
)<OverviewAndModuleSwitchContainerProps>`
  padding-bottom: ${({ articleHasRelatedArticles }) =>
    !articleHasRelatedArticles && '4.5rem'};
`;

export const MainBodyContainer = styled(Base)`
  ${({ theme }) => theme.global.articleMainPanelStyling};
`;

export const CarouselTitleContainer = styled(Base)`
  ${({ theme }) => theme.typography.variants.primary.lg};
  margin: 2.5rem 0 2rem;

  ${Theme.mediaQueries.md} {
    margin: 3rem auto 1.4rem;
    width: ${({ theme }) => theme.sizes.articleContentWidthTablet};
  }

  ${Theme.mediaQueries.lg} {
    width: ${({ theme }) => theme.sizes.articleContentWidthXlDesktop};
  }
`;

export const CarouselModuleContainer = styled(Base)`
  ${({ theme }) => theme.global.articleMainPanelStyling};
  padding-right: unset !important;
  width: unset !important;

  ${Theme.mediaQueries.md} {
    padding-left: 1rem !important;
  }
`;

export const ReferencesTitle = styled.h2`
  ${({ theme }) => theme.typography.variants.primary.lg};
  margin: 2.5rem 0 2rem;

  ${Theme.mediaQueries.md} {
    margin: 3rem 0 1.5rem;
  }
`;

export const ReferencesContainer = styled(Base)`
  word-break: break-all;
  ${({ theme }) => theme.global.articleMainPanelStyling};
`;
